import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { FieldReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { FieldEffects } from './effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('field', FieldReducer),
    EffectsModule.forFeature([FieldEffects])
  ]
})
export class FieldStoreModule { }
